// MESSAGES
import ReportsFormattedMessages from '../messages/reports/ReportsFormattedMessages';

const godAmin = { accessLevel: '3', accessType: '3' };

export const ReportsRoutes = [
  {
    label: 'Customer Reports',
    ...godAmin,
  },
  {
    path: '/reports/cost-center',
    label: ReportsFormattedMessages.costCentreButton,
  },
  {
    path: '/reports/user',
    label: ReportsFormattedMessages.userButton,
  },
  {
    path: '/reports/message',
    label: ReportsFormattedMessages.messageButton,
  },
  {
    path: '/reports/reply',
    label: ReportsFormattedMessages.replyButton,
  },
  {
    label: 'Admin Reports',
    ...godAmin,
  },
  {
    path: '/reports/allsends',
    label: ReportsFormattedMessages.allSendsButton,
    ...godAmin,
  },
  {
    path: '/reports/allreply',
    label: ReportsFormattedMessages.allReplyButton,
    ...godAmin,
  },
  {
    path: '/reports/carrier',
    label: ReportsFormattedMessages.carrierButton,
    ...godAmin,
  },
  {
    path: '/reports/customer',
    label: ReportsFormattedMessages.customerButton,
    ...godAmin,
  },
  {
    path: '/reports/incoming',
    label: ReportsFormattedMessages.incomingButton,
    ...godAmin,
  },
  {
    path: '/reports/outgoing',
    label: ReportsFormattedMessages.outgoingButton,
    ...godAmin,
  },
  {
    path: '/reports/provider',
    label: ReportsFormattedMessages.providerButton,
    ...godAmin,
  },
  {
    path: '/reports/top-user',
    label: ReportsFormattedMessages.topUserButton,
    ...godAmin,
  },
];
